<template>
  <div class="flex w-full flex-col gap-6 p-6">
    <nav class="pb-3" aria-label="Breadcrumb">
      <ol class="flex space-x-1 truncate text-xs md:space-x-4 md:text-sm">
        <li>
          <div>
            <router-link to="/" class="text-gray-400 hover:text-gray-400">
              <span v-html="$icons.home"></span>

              <span class="sr-only">Home</span>
            </router-link>
          </div>
        </li>
        <li v-for="(item, i) in breadcrumb" :key="i">
          <div class="flex items-center">
            <span class="text-gray-400" v-html="$icons.chevron_right"></span>

            <router-link
              :to="item.url"
              class="ml-1 text-xs font-medium text-gray-400 hover:text-gray-700 md:ml-4 md:text-sm"
            >
              {{ item.name }}
            </router-link>
          </div>
        </li>
      </ol>
    </nav>
    <div class="mx-auto flex w-2/3 flex-col gap-6">
      <div class="flex items-center justify-between">
        <div>
          <div class="flex items-center gap-4">
            <i v-html="$icons.edit_document"> </i>
            <h3 class="text-2xl font-bold">Pré autorização de Trade Ideas</h3>
          </div>
          <span class="text-sm text-gray-500 dark:text-gray-400">
            Deixe suas operações Trade Ideas pré autorizadas por um prazo determinado.
          </span>
        </div>
      </div>
      <div class="flex w-full justify-between gap-4">
        <div class="col-span-2 flex items-center">
          <label> Estratégia </label>
        </div>
        <div class="relative max-w-[300px]">
          <div class="flex h-10 w-full items-center">
            <input
              type="text"
              class="bg-ontick-graphite-500 h-full w-full rounded border-0 !pl-10 text-sm"
              placeholder="Buscar"
              v-model="search"
            />
            <button
              v-if="search_results.length"
              class="bg-ontick-graphite-500 absolute top-0 right-0 h-full rounded-r px-2 transition-all hover:brightness-125"
            >
              <div class="rotate-90 transform">
                <i v-html="icons.chevron_right"></i>
              </div>
            </button>
          </div>
          <span class="absolute top-1/2 left-2 -translate-y-1/2">
            <i v-html="$icons.search"></i>
          </span>

          <!-- Resultados -->
          <ul
            v-if="strategy_dropdown_enabled"
            class="absolute top-12 right-0 z-10 max-h-96 w-full overflow-y-auto rounded shadow-lg"
          >
            <li v-for="item in search_results" :key="item.auth_strat_id" class="w-full">
              <button class="bg-ontick-graphite-500 w-full py-2 px-2 text-left" @click="selectStrategy(item)">
                {{ item.strategy_name }}
              </button>
            </li>
          </ul>
        </div>
      </div>
      <!-- <div class="flex h-10 w-full justify-between gap-4">
        <div class="col-span-2 flex items-center">
          <label> Limite máximo de operações simultâneas </label>
        </div>
        <select
          class="bg-ontick-graphite-500 disabled:bg-ontick-steel-500 h-full w-full max-w-[300px] rounded border-0 text-sm text-gray-400"
          v-model="max_positions"
          :disabled="!selected_strategy.strategy_max_positions"
        >
          <option disabled selected value="">Selecione</option>
          <option v-for="item in operationsArray" :key="item" :value="item">
            {{ item }}
          </option>
        </select>
      </div> -->
      <div class="flex w-full justify-between gap-4">
        <div class="col-span-2 flex flex-col justify-center">
          <label> Alocação máxima (R$)</label>
        </div>
        <div class="flex w-[300px] flex-col gap-2">
          <input
            class="bg-ontick-graphite-500 disabled:bg-ontick-steel-500 h-10 w-full max-w-[300px] rounded border-0 px-2 text-sm text-gray-400"
            v-model="user_max_exposure"
            :disabled="!(selected_strategy.strategy_min_capital || selected_strategy.strategy_max_capital)"
            placeholder="Alocação máxima"
            v-money="money"
          />
          <div
            class="flex items-center justify-between gap-4"
            v-if="selected_strategy.strategy_min_capital || selected_strategy.strategy_max_capital"
          >
            <span class="text-xs text-gray-400" v-if="selected_strategy.strategy_min_capital">
              Mín.:
              <span>
                {{ selected_strategy.strategy_min_capital | currency }}
              </span>
            </span>
            <span class="text-xs text-gray-400" v-if="selected_strategy.strategy_max_capital">
              Máx.:
              <span>
                {{ selected_strategy.strategy_max_capital | currency }}
              </span>
            </span>
          </div>
        </div>
      </div>
      <button
        @click="confirm"
        :disabled="buttonDisabled"
        class="dark:disabled:bg-ontick-graphite-500 bg-ontick-blue-600 dark:bg-ontick-blue-900 flex h-10 w-full items-center justify-center gap-2 rounded-md px-4 text-sm font-semibold text-white shadow filter transition-all hover:brightness-110 disabled:cursor-not-allowed disabled:filter-none dark:disabled:text-gray-400"
      >
        <span> Autorizar </span>
      </button>
    </div>
    <portal to="modal">
      <ontick-modal-component
        :open="user_pin_modal_is_active"
        :size="'small'"
        :showCloseButton="false"
        @close="user_pin_modal_is_active = false"
      >
        <div class="flex flex-col items-center gap-4">
          <div class="text-center">
            <p class="text-2xl">Assinatura eletrônica</p>
            <p class="text-xs">Digite sua assinatura eletrônica de 4 digitos para confirmar esta ação:</p>
          </div>
          <ontick-pin-code-input-component v-model="user_pin" />
          <p class="text-xs">
            Esqueceu sua assinatura?
            <a
              href="https://ajuda.ontick.com.br/portal/pt-br/kb/articles/como-gerar-nova-assinatura-eletronica-ontick"
              target="_blank"
              class="text-ontick-blue-600 filter transition-all hover:brightness-125"
            >
              Clique aqui.
            </a>
          </p>
          <button
            @click="createAuth"
            :disabled="user_pin.length !== 4"
            class="bg-ontick-blue-800 disabled:bg-ontick-graphite-500 w-full rounded-md py-2 font-semibold filter transition-all hover:brightness-125 disabled:cursor-not-allowed disabled:filter-none"
          >
            Autorizar
          </button>
        </div>
      </ontick-modal-component>
    </portal>
  </div>
</template>

<script>
import { VMoney } from "v-money";
import { mapGetters } from "vuex";
import ontickEditableSelectComponent from "../../../shared/components/basic/ontick-editable-select.component.vue";
import OntickModalComponent from "../../../shared/components/basic/ontick-modal.component.vue";
import OntickPinCodeInputComponent from "../../../shared/components/basic/ontick-pin-code-input.component.vue";
import routes from "../../../core/config/api-ontick.routes";
import { iconsSet as icons } from "../../../assets/icons/icons";
import Joi from "joi";
export default {
  directives: {
    money: VMoney,
  },

  components: {
    ontickEditableSelectComponent,
    OntickModalComponent,
    OntickPinCodeInputComponent,
  },

  data() {
    return {
      icons,
      strategy: {},
      search: "",
      search_results: [],
      strategy_dropdown_enabled: false,
      selected_strategy: {},
      max_positions: "",
      max_per_position: undefined,
      user_max_exposure: undefined,
      user_pin_modal_is_active: false,
      user_pin: "",
      min_allocation: null,
      max_allocation: null,
    };
  },

  computed: {
    ...mapGetters({
      getSelectedAccount: "accountTypes/getSelectedAccount",
      getConfigs: "config/getConfigs",
    }),
    breadcrumb() {
      return [
        {
          name: "Trade Ideas",
          url: { name: "Trade Ideas v2" },
        },
        {
          name: "Pré-autorização",
          url: { name: "Pré-autorização Trade Ideas v2" },
        },
        {
          name: "Nova autorização",
          url: { name: "Nova autorização Trade Ideas v2" },
        },
      ];
    },
    exposureNumber() {
      return Number(
        this.user_max_exposure.replaceAll("R$", "").replaceAll(" ", "").replaceAll(".", "").replaceAll(",", ".")
      );
    },
    buttonDisabled() {
      return !(
        Object.values(this.selected_strategy).length &&
        this.exposureNumber >= this.selected_strategy.strategy_min_capital &&
        this.exposureNumber <= this.selected_strategy.strategy_max_capital
      );
    },
    searchValue() {
      return this.formFields.find((item) => item.label == "Estratégia").value || "";
    },
    operationsArray() {
      if (!Object.keys(this.selected_strategy)) {
        return;
      }

      let arr = [];
      for (let i = 1; i <= this.selected_strategy.strategy_max_positions; i++) {
        arr.push(i);
      }
      return arr;
    },
  },

  methods: {
    selectStrategy(strategy) {
      this.selected_strategy = strategy;
      this.search = strategy.strategy_name;
      this.strategy_dropdown_enabled = false;
    },
    async strategy_name(chars) {
      try {
        const { data } = await this.$api.get(routes.SEARCH_AUTH_STRATEGIES, {
          params: { chars },
        });
        this.search_results = data.map((item) => {
          return {
            ...item,
            label: item.strategy_name,
            value: item.auth_strat_id,
          };
        });
        if (this.search_results.length) {
          this.strategy_dropdown_enabled = true;
        }
      } catch (err) {
        console.error(err);
      }
    },

    async createAuth() {
      const schema = Joi.object({
        account_id: Joi.number().required(),
        auth_strat_id: Joi.number().required(),
        user_max_exposure: Joi.number().required(),
        user_code: Joi.string().pattern(/\d/).length(4).required(),
      });

      try {
        const account_id = this.getSelectedAccount.account_id;

        const body = {
          account_id,
          auth_strat_id: this.selected_strategy.auth_strat_id,
          user_max_exposure: this.user_max_exposure.replaceAll("R$ ", "").replaceAll(".", "").replaceAll(",", "."),
          user_code: this.user_pin,
        };
        try {
          const value = await schema.validateAsync(body);
          const { data } = await this.$api.post(routes.CREATE_TRADE_IDEA_AUTHORIZATION, value);
          this.$swal("Sucesso", data.msg, "success");
          this.$router.push({ name: "Pré-autorização Trade Ideas v2" });
        } catch (err) {
          console.log(err);
          this.$swal("Erro", err.data.msg, "error");
        }
      } catch (err) {
        console.error(err);
        this.$swal("Erro", err.data.msg, "error");
      }
    },
    confirm() {
      this.user_pin_modal_is_active = true;
    },
  },

  watch: {
    search: {
      handler(chars) {
        if (chars.length >= 3) {
          this.strategy_name(chars);
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.input {
  @apply border-ontick-steel-300 dark:bg-ontick-graphite-500 dark:disabled:bg-ontick-graphite-500 h-10 w-full rounded border-2 px-2 text-sm shadow disabled:cursor-not-allowed disabled:border disabled:bg-gray-400 dark:border-0 dark:disabled:text-gray-500;
}
</style>
